import React, { useState, useMemo, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Modal, Spinner } from "react-bootstrap";
import { MoveLeft, ChevronLeft, ChevronRight } from "lucide-react";
import { DocUploader } from "../../common/DocUploader";
import chevron_down from "../../../assets/Vehicles/chevron_down.png";
import Dropdown from "react-bootstrap/Dropdown";
import DatePicker from "react-datepicker";
import { Calendar } from "lucide-react";
import user from "../../../assets/Dashboard/user.png";
import { Plus } from "lucide-react";
import labor from "../../../assets/svg/Labor.svg";
import parts from "../../../assets/svg/parts.svg";
import total from "../../../assets/svg/total.svg";
import down from "../../../assets/Vehicles/chevron_down.png";

import { useReactTable, getCoreRowModel, getSortedRowModel, getFilteredRowModel, getPaginationRowModel, flexRender } from "@tanstack/react-table";
import { Columns } from "../../Vehicles/Column";
import MOCK_DATA from "../../Vehicles/MOCK_DATA.json";
import CommonDropdown from "../../common/common_dropDown";
import { submitServiceAPI, updateServiceAPI, getVehicleDetailsApi, getServiceEditApi, saveServiceAttachmentApi } from "../services-api";
import ErrorExtractor from "../../common/error_extractor";
import DOMPurify from "dompurify";
import { Toast } from "bootstrap/dist/js/bootstrap.bundle.min";
import attachment from "../../../assets/png/attachment.png";
import download from "../../../assets/svg/download.svg";
import closeAttachment from "../../../assets/svg/close-red.svg";
import editIcon from "../../../assets/svg/edit.svg";
import delIcon from "../../../assets/svg/delete.svg";

export const AddService = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};

  const [selectedDate, setSelectedDate] = useState();
  //   const [selectedDates, setSelectedDates] = useState(new Date());
  const columns = [
    {
      header: "Item",
      accessorKey: "item",
      cell: ({ getValue, row }) => {
        const error = errorMsg.items[row.index]?.item_id;
        return (
          <div>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "150px",
              }}
            >
              {getValue()}
            </div>
            {error?.length > 0 && (
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {error[0]}
              </span>
            )}
          </div>
        );
      },
    },

    {
      header: "Labour",
      accessorKey: "labour",
      cell: ({ getValue, row }) => {
        const error = errorMsg.items[row.index]?.labour_id;
        return (
          <div>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "200px",
              }}
            >
              {getValue()}
            </div>
            {error?.length > 0 && (
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {error[0]}
              </span>
            )}
          </div>
        );
      },
    },
    {
      header: "Part",
      accessorKey: "part",
      cell: ({ getValue, row }) => {
        const error = errorMsg.items[row.index]?.part;
        return (
          <div>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "200px",
              }}
            >
              {getValue()}
            </div>
            {error?.length > 0 && (
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {error[0]}
              </span>
            )}
          </div>
        );
      },
    },
    {
      header: "Labour Cost",
      accessorKey: "labour_cost",
      cell: ({ getValue, row }) => {
        const error = errorMsg.items[row.index]?.labour_cost;
        return (
          <div>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "150px",
              }}
            >
              {getValue()}
            </div>
            {error?.length > 0 && (
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {error[0]}
              </span>
            )}
          </div>
        );
      },
    },

    {
      header: "Part Cost",
      accessorKey: "part_cost",
      cell: ({ getValue, row }) => {
        const error = errorMsg.items[row.index]?.part_cost;
        return (
          <div>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "150px",
              }}
            >
              {getValue()}
            </div>
            {error?.length > 0 && (
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {error[0]}
              </span>
            )}
          </div>
        );
      },
    },

    {
      header: "Total Cost",
      accessorKey: "totalcost",
      cell: (info) => {
        console.log(info);
        return (
          <div
            className="hover-action-cell"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              minWidth: "150px",
              maxWidth: "200px",
              position: "relative",
            }}
          >
            <span>{parseInt(info.row.original.labour_cost, 0) + parseInt(info.row.original.part_cost, 0)}</span>
            <div className="click-actions">
              <button
                className="icon-btn"
                onClick={(e) => {
                  e.stopPropagation(); // prevent triggering row click
                  setEditIndex(info.row.id);
                  setItemOption({
                    value: info.row.original.item_id ?? "",
                    label: info.row.original.item ?? "",
                  });
                  setLaborOption({
                    value: info.row.original.labour_id ?? "",
                    label: info.row.original.labour ?? "",
                  });
                  setPartName(info.row.original.part ?? "");
                  setLaborCost(info.row.original.labour_cost ?? "");
                  setPartCost(info.row.original.part_cost ?? "");
                  setShowModal(true);
                }}
              >
                <img src={editIcon} alt="edit" />
              </button>
              <button
                className="icon-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  console.log(info.row.id);
                  const newItems = [...itemList];
                  setRemoveItemList([...removeItemList, info.row.original.id]);
                  newItems.splice(info.row.id, 1);
                  setItemList(newItems);
                  // setItemList([...itemList.slice(0, itemList.filter((_, i) => i !== info.row.id)), ...itemList.slice(itemList.filter((_, i) => i !== info.row.id) + 1)]);
                  /*  setDeleteId(info.row.original.id); */
                }}
              >
                <img src={delIcon} alt="delete" />
              </button>
            </div>
          </div>
        );
      },
    },
  ];
  const data = useMemo(() => MOCK_DATA, []);
  const [globalFilter, setGlobalFilter] = useState("");

  //   popup
  const [showModal, setShowModal] = useState(false);

  const handleOpen = () => setShowModal(true);
  const handleClose = () => {
    setShowModal(false);
    resetItem();
    setEditIndex(-1);
  };

  useEffect(() => {
    if (id != null && id !== 0) {
      getServiceEdit(id);
    }
  }, [id]);

  const [licensePlateOption, setLicensePlateOption] = useState(null);
  const [vehicleName, setVehicleName] = useState("");
  const [issueOption, setIssueOption] = useState(null);
  const [vendorOption, setVendorOption] = useState(null);
  const [startOdometer, setStartOdometer] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [editIndex, setEditIndex] = useState(-1);
  const [itemOption, setItemOption] = useState(null);
  const [laborOption, setLaborOption] = useState(null);
  const [partName, setPartName] = useState("");
  const [laborCost, setLaborCost] = useState("");
  const [partCost, setPartCost] = useState("");

  const resetItem = () => {
    setItemOption(null);
    setLaborOption(null);
    setPartName("");
    setLaborCost("");
    setPartCost("");
  };
  const [dragging, setDragging] = useState(false);
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [attachmentList, setAttachmentList] = useState([]);
  const [removedAttachmentList, setRemovedAttachmentList] = useState([]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const handleSelectLicensePlate = (item) => {
    setLicensePlateOption(item); // store selected id
    getVehicleDetails(item.value);
  };
  const handleSelectVendor = (item) => {
    setVendorOption(item);
  };
  const handleSelectIssue = (item) => {
    setIssueOption(item);
  };
  const getVehicleDetails = async (id) => {
    try {
      const response = await getVehicleDetailsApi(id);
      console.log(response.data);
      if (response.data.success === true) {
        setVehicleName(response.data.vehicle?.name ?? "");
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handleSelectItem = (item) => {
    setItemOption(item);
  };
  const handleSelectLabor = (item) => {
    setLaborOption(item);
  };

  const [errorMsg, setErrorMsg] = useState({
    vehicle_id: "",
    odometer: "",
    vendor_id: "",
    issue_id: "",
    start_date: "",
    end_date: "",
    items: [],
    images: "",
  });
  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };

  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const [itemList, setItemList] = useState([]);
  const [removeItemList, setRemoveItemList] = useState([]);
  const [itemErrorList, setItemErrorList] = useState([]);

  const table = useReactTable({
    data: itemList ?? [],
    columns,
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });
  const pageOptions = table.getPageOptions();
  const { pageIndex, pageSize } = table.getState().pagination;

  const [isLoader, setIsLoader] = useState(false);

  const submitForm = async () => {
    setIsLoader(true);
    const extractor = new ErrorExtractor();
    try {
      if (!licensePlateOption?.value || !vendorOption?.value || !startOdometer || !startDate || !endDate) {
        setErrorMsg({
          vehicle_id: !licensePlateOption?.value ? "License plate is required" : "",
          vendor_id: !vendorOption?.value ? "Vendor is required" : "",
          odometer: !startOdometer ? "Odometer is required" : "",
          start_date: !startDate ? "Start date is required" : "",
          end_date: !endDate ? "End date is required" : "",
          items: (!itemList || itemList.length === 0) ? "At least one line item is required" : [],
        });
        setIsLoader(false);
        return;
      }

      const preSanitizeData = {
        vehicle_id: licensePlateOption != null ? licensePlateOption.value : "",
        odometer: startOdometer,
        vendor_id: vendorOption != null ? vendorOption.value : "",
        issue_id: issueOption != null ? issueOption.value : "",
        start_date: startDate != null && startDate !== "" ? startDate.toLocaleDateString("en-CA") : "",
        end_date: endDate != null && endDate !== "" ? endDate.toLocaleDateString("en-CA") : "",
        items: itemList ?? [],
        removed_images: removedAttachmentList ?? [],
        removed_items: removeItemList ?? [],
        images: [],
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      var response = null;
      if (id == null) {
        response = await submitServiceAPI(sanitizedData);
      } else {
        response = await updateServiceAPI(id, sanitizedData);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            vehicle_id: "",
            odometer: "",
            vendor_id: "",
            issue_id: "",
            start_date: "",
            end_date: "",
            items: [],
            images: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}:`, value);

            if (key === "items") {
              if (Array.isArray(value)) {
                if (value.length > 0 && typeof value[0] === "string") {
                  // It's an array of strings
                  validationTemp[key] = value.length === 0 ? "" : value[0];
                } else if (value.length > 0 && typeof value[0] === "object") {
                  // It's an array of objects
                  // Here you can process the first object or all objects depending on your need
                  validationTemp[key] = value; // Assign the object itself
                } else {
                  validationTemp[key] = ""; // fallback
                }
              } else {
                validationTemp[key] = ""; // fallback
              }
            } else {
              // Normal case for other fields
              validationTemp[key] = value.length === 0 ? "" : value[0];
            }
          });

          console.log("validationTemp...", validationTemp);
          setItemErrorList(validationTemp.items ?? []);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        console.log("saveAttachment called 0");
        if (attachmentList.length === 0) {
          console.log("saveAttachment called 1");
          navigate(-1);
        } else {
          console.log("saveAttachment called 2");
          saveAttachment(response.data.id);
        }
      }
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (err.response && err.response.status === 400 && err.response.data.error) {
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setItemErrorList(errorvalue.items ?? []);
        console.log(errorvalue.items ?? []);
        console.log(itemErrorList);
        setErrorMsg(errorvalue);
      }
    } finally {
      setIsLoader(false);
    }
  };
  const saveAttachment = async (workOrderId) => {
    console.log("saveAttachment called");
    try {
      const data = {
        attachment: attachmentList.map((item) => item.base64),
      };
      const response = await saveServiceAttachmentApi(workOrderId, data);
      if (response.data.success === true) {
        navigate(-1);
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  };

  const getServiceEdit = async (id) => {
    try {
      const response = await getServiceEditApi(id);

      if (response.data.success === true) {
        const workOrderDetail = response.data.service ?? {};

        setLicensePlateOption({
          value: workOrderDetail.vehicle_id ?? "",
          label: workOrderDetail.lic_no ?? "",
        });
        setVehicleName(workOrderDetail.name ?? "");
        setStartOdometer(workOrderDetail.odometer ?? "");
        setVendorOption({
          value: workOrderDetail.vendor_id ?? "",
          label: workOrderDetail.vendor ?? "",
        });
        setIssueOption({
          value: workOrderDetail.issue_id ?? "",
          label: workOrderDetail.issue ?? "",
        });
        setStartDate(workOrderDetail.start_date != null && workOrderDetail.start_date !== "" ? new Date(workOrderDetail.start_date) : null);
        setEndDate(workOrderDetail.completion_date != null && workOrderDetail.completion_date !== "" ? new Date(workOrderDetail.completion_date) : null);
        setAttachmentURLList(workOrderDetail.images ?? []);
        setItemList(workOrderDetail.items ?? []);
      } else {
        console.error("Error fetching service details:", response.data.message);
        navigate(-1);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  return (
    <div className="bg-half-white">
      <div className="px-3 bg-white">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex gap-3 my-3">
            <MoveLeft className="cursor-pointer" onClick={() => navigate(-1)} />
            <p className="fw-semibold m-0">{id != null ? "Update service" : "New service"}</p>
          </div>
          <div className="d-flex gap-3">
            <Button className="bg-white rounded-pill px-4 py-2 pagination-color btn-border-grey" onClick={() => navigate(-1)}>
              Cancel
            </Button>
            <Button
              onClick={submitForm}
              disabled={isLoader}
              className={`dark-purple-btn rounded-pill py-2 px-4 d-flex justify-content-center align-items-center ${isLoader ? "disabled-btn" : ""}`}
              style={{ minWidth: "100px" }}
            >
              {isLoader ? <Spinner animation="border" size="sm" /> : id != null ? "Update" : "Save"}
            </Button>
          </div>
        </div>
      </div>
      <div className="px-2">
        <DocUploader
          label="Upload document"
          description="Add a document here by dragging and dropping, or choose files manually."
          onFileSelect={(file) => {
            if (file) {
              const reader = new FileReader();
              reader.onload = async () => {
                const base64String = await reader.result;
                setAttachmentList([
                  ...attachmentList,
                  {
                    name: file.name,
                    base64: base64String,
                    size: formatBytes(file.size),
                  },
                ]);
              };
              reader.readAsDataURL(file);
            }
          }}
        />
        {attachmentURLList.length > 0 && (
          <div
            style={{
              marginTop: "16px",
              marginBottom: "16px",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "start",
              gap: "16px",
            }}
          >
            {attachmentURLList.map((item, attachIndex) => (
              <div
                style={{
                  width: "312px",
                  height: "62px",
                  borderRadius: "12px",
                  padding: "12px 16px 12px 16px",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img src={attachment} style={{ width: "37px", height: "36px" }} />
                <div
                  style={{
                    width: "240px",
                    marginLeft: "8px",
                    marginTop: "4px",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "500px",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      marginBottom: "2px",
                    }}
                  >
                    {item.name}
                  </span>
                  <br />
                  <p
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "400px",
                      fontSize: "12px",
                      lineHeight: "16.2px",
                      color: "#8790A1",
                    }}
                  >
                    {item.size}
                  </p>
                </div>

                {item.url && (
                  <div
                    onClick={() => {
                      downloadFile(item.url, item.url.split("/").pop());
                    }}
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "100px",
                    }}
                  >
                    <img
                      src={download}
                      style={{
                        width: "12.8px",
                        height: "12px",
                        top: "10px",
                        left: "9.6px",
                      }}
                    />
                  </div>
                )}

                <div
                  style={{
                    position: "relative",
                    width: "32px",
                    height: "32px",
                    borderRadius: "100px",
                    marginLeft: "4px",
                  }}
                >
                  <img
                    src={closeAttachment}
                    style={{
                      width: "12.8px",
                      height: "12px",
                      top: "10px",
                      left: "9.6px",
                    }}
                    alt="remove"
                    onClick={() => {
                      /* removeAttachment(item.id); */
                      setRemovedAttachmentList([...removedAttachmentList, item.id]);
                      setAttachmentURLList(attachmentURLList.filter((_, i) => i !== attachIndex));
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
        {attachmentList.length > 0 && (
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "start",
              gap: "16px",
            }}
          >
            {attachmentList.map((item, attachIndex) => (
              <div
                style={{
                  width: "312px",
                  height: "62px",
                  borderRadius: "12px",
                  padding: "12px 16px 12px 16px",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img src={attachment} style={{ width: "37px", height: "36px" }} />
                <div
                  style={{
                    width: "210px",
                    marginLeft: "8px",
                    marginTop: "4px",
                  }}
                >
                  <div
                    style={{
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      fontWeight: "500px",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      marginBottom: "2px",
                    }}
                  >
                    {item.name}
                  </div>
                  <p
                    style={{
                      fontWeight: "400px",
                      fontSize: "12px",
                      lineHeight: "16.2px",
                      color: "#8790A1",
                    }}
                  >
                    {item.size}
                  </p>
                </div>

                <div
                  style={{
                    position: "relative",
                    width: "32px",
                    height: "32px",
                    borderRadius: "100px",
                    marginLeft: "4px",
                  }}
                >
                  <img
                    src={closeAttachment}
                    style={{
                      width: "12.8px",
                      height: "12px",
                      top: "10px",
                      left: "9.6px",
                    }}
                    onClick={() => {
                      setAttachmentList(attachmentList.filter((_, i) => i !== attachIndex));
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="row  m-0 px-2 mb-3">
        <div className="bg-white rounded-4 col-xl-12 md-12 ">
          <div className="m-0 px-1 mb-3">
            <div className=" p-3 rounded-4">
              <div className="row">
                <div className="col-xl-12">
                  <p className="fs-18 fw-600 mb-0">Service Details </p>
                </div>
                {/*  <div className="col-xl-6">
                  <label htmlFor="vin" className="form-label fw-400">
                    Service
                  </label>
                  <Dropdown className="mb-3">
                    <Dropdown.Toggle
                      id="vin"
                      className="bg-white w-100 btn-border-grey assignment-dropdown rounded-3 px-4 d-flex justify-content-between align-items-center gap-2"
                      style={{ color: "#8790A1" }}
                    >
                      Select <img src={chevron_down} alt="chev down" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                      <Dropdown.Item href="#/action-1">
                        Not assigned
                      </Dropdown.Item>
                      <Dropdown.Item href="#/action-1">
                        Not active
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div> */}
                <div className="col-xl-6 col-12">
                  <label htmlFor="vinOption" className="form-label  fw-400 mt-2 d-flex">
                    License Plate<span className="error-text">*</span>
                  </label>
                  <CommonDropdown apiUrl={`${apiUrl}get_vehicle`} placeholder="Select VIN" value={licensePlateOption} onSelect={handleSelectLicensePlate} />{" "}
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#FF4444",
                      marginTop: "6px",
                      marginLeft: "6px",
                    }}
                  >
                    {errorMsg.vehicle_id}
                  </span>
                </div>
                <div className="col-xl-6 col-12">
                  <label htmlFor="license" className="form-label  fw-400 mt-2">
                    Vehicle Name
                  </label>
                  <input type="text" className="form-control rounded-3 vehicle-form-input" id="license" value={vehicleName} readOnly={true} />{" "}
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#FF4444",
                      marginTop: "6px",
                      marginLeft: "6px",
                    }}
                  >
                    {errorMsg.lic_no}
                  </span>
                </div>

                <div className="col-xl-6 col-12">
                  <label htmlFor="StartOdometer" className="form-label  fw-400 mt-3 d-flex">
                    Start Odometer <span className="error-text">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control rounded-3 vehicle-form-input"
                    id="StartOdometer"
                    value={startOdometer}
                    placeholder="Enter here..."
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setStartOdometer(value);
                    }}
                  />
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#FF4444",
                      marginTop: "6px",
                      marginLeft: "6px",
                    }}
                  >
                    {errorMsg.odometer}
                  </span>
                </div>

                <div className="col-xl-6 col-12">
                  <label htmlFor="vinOption" className="form-label  fw-400 mt-3 d-flex">
                    Vendor<span className="error-text">*</span>
                  </label>
                  <CommonDropdown apiUrl={`${apiUrl}get_vendors`} placeholder="Select Vendor" value={vendorOption} onSelect={handleSelectVendor} />{" "}
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#FF4444",
                      marginTop: "6px",
                      marginLeft: "6px",
                    }}
                  >
                    {errorMsg.vendor_id}
                  </span>
                </div>

                <div className="col-xl-6 d-flex flex-column mt-3">
                  <label htmlFor="date" className="form-label fw-400 d-flex">
                    Start Date<span className="error-text">*</span>
                  </label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    dateFormat="yyyy-MM-dd"
                    customInput={
                      <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                        {startDate ? startDate.toLocaleDateString() : <span style={{ color: "#8790A1" }}>mm/dd/yyyy</span>}
                        <Calendar size={16} />
                      </button>
                    }
                  />
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#FF4444",
                      marginTop: "6px",
                      marginLeft: "6px",
                    }}
                  >
                    {errorMsg.start_date}
                  </span>
                </div>
                <div className="col-xl-6 d-flex flex-column mt-3">
                  <label htmlFor="date" className="form-label fw-400 d-flex">
                    End Date<span className="error-text">*</span>
                  </label>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    dateFormat="yyyy-MM-dd"
                    minDate={startDate}
                    customInput={
                      <button style={{ color: "#8790A1" }} className="btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                        {endDate ? endDate.toLocaleDateString() : <span style={{ color: "#8790A1" }}>mm/dd/yyyy</span>}
                        <Calendar size={16} />
                      </button>
                    }
                  />
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#FF4444",
                      marginTop: "6px",
                      marginLeft: "6px",
                    }}
                  >
                    {errorMsg.end_date}
                  </span>
                </div>

                <div className="col-xl-12">
                  <label htmlFor="vinOption" className="form-label  fw-400 mt-3">
                    Issue
                  </label>
                  <CommonDropdown apiUrl={`${apiUrl}get_issues`} placeholder="Select Issue" value={issueOption} onSelect={handleSelectIssue} />{" "}
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#FF4444",
                      marginTop: "6px",
                      marginLeft: "6px",
                    }}
                  >
                    {errorMsg.issue_id}
                  </span>
                </div>
                {/* <div className="d-flex gap-3 justify-content-end mt-5">
                  <Button className="bg-white rounded-3 px-4 py-2 pagination-color btn-border-grey">
                    Cancel
                  </Button>
                  <Button className="dark-purple-btn rounded-3 py-2 px-4">
                    Save
                  </Button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-xl-5">
            <div
              className="bg-white rounded-4 p-3 overflow-y-auto hide-scroll"
              style={{ height: "580px" }}
            >
              <div>
                <h6 className="fw-700 fs-16 mb-3">
                  Recent comments - {comments.length}
                </h6>
                {comments.map((comment, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-start justify-content-between py-3 border-bottom"
                    style={{ fontSize: "14px" }}
                  >
                    <div className="d-flex">
                      <div
                        className="rounded-circle bg-light d-flex align-items-center justify-content-center me-3"
                        style={{ width: "40px", height: "40px" }}
                      >
                        <img src={user} alt="" />
                      </div>
                      <div>
                        <div className="fw-500 fs-13">{comment.name}</div>
                        <div className="text-muted fw-400 fs-12">
                          {comment.message}
                        </div>
                      </div>
                    </div>
                    <p className="text-muted fw-500 fs-11">{comment.time}</p>
                  </div>
                ))}
              </div>
            </div>
          </div> */}

        <div className="bg-white rounded-4 p-3 mt-2">
          <div className="d-flex justify-content-between align-items-center">
            <p className="m-0 fs-18 fw-600">Line Items</p>
            <Button className="dark-purple-btn border-0 d-flex gap-1 px-3 rounded-3 text-white" onClick={handleOpen}>
              <Plus />
              Add new
            </Button>
            <Modal show={showModal} onHide={handleClose} centered className="rounded-4">
              <Modal.Header closeButton className="border-0">
                <Modal.Title>Add item</Modal.Title>
              </Modal.Header>
              <Modal.Body className="pt-0">
                <form className="d-flex flex-column gap-3">
                  <div>
                    <label className="form-label">Item</label>
                    <CommonDropdown apiUrl={`${apiUrl}get_items`} placeholder="Select item" value={itemOption} onSelect={handleSelectItem} />
                  </div>

                  <div>
                    <label htmlFor="vin" className="form-label fw-400">
                      Labor
                    </label>
                    <CommonDropdown apiUrl={`${apiUrl}get_labours`} placeholder="Select labor" value={laborOption} onSelect={handleSelectLabor} />
                  </div>

                  <div>
                    <label className="form-label">Part</label>
                    <input type="text" className="form-control rounded-3" placeholder="Enter here..." value={partName} onChange={(e) => setPartName(e.target.value)} />
                  </div>

                  <div className="d-flex gap-3">
                    <div className="flex-fill">
                      <label className="form-label">Labor cost</label>
                      <input type="number" className="form-control rounded-3" placeholder="Enter here..." value={laborCost} onChange={(e) => setLaborCost(e.target.value)} />
                    </div>
                    <div className="flex-fill">
                      <label className="form-label">Parts cost</label>
                      <input type="number" className="form-control rounded-3" placeholder="Enter here..." value={partCost} onChange={(e) => setPartCost(e.target.value)} />
                    </div>
                  </div>
                </form>
              </Modal.Body>
              <Modal.Footer className="border-0 d-inline">
                <div className="row">
                  <div className="col-6">
                    <Button variant="light" className="rounded-pill px-4 w-100" onClick={handleClose}>
                      Cancel
                    </Button>
                  </div>
                  <div className="col-6">
                    <Button
                      onClick={() => {
                        if (editIndex === -1) {
                          setItemList([
                            ...itemList,
                            {
                              item_id: itemOption != null ? itemOption.value : "",
                              item: itemOption != null ? itemOption.label : "",
                              labour_id: laborOption != null ? laborOption.value : "",
                              labour: laborOption != null ? laborOption.label : "",
                              part: partName,
                              labour_cost: laborCost,
                              part_cost: partCost,
                            },
                          ]);
                        } else {
                          const newItems = [...itemList];
                          newItems[editIndex].item_id = itemOption != null ? itemOption.value : "";
                          newItems[editIndex].item = itemOption != null ? itemOption.label : "";
                          newItems[editIndex].labour_id = laborOption != null ? laborOption.value : "";
                          newItems[editIndex].labour = laborOption != null ? laborOption.label : "";
                          newItems[editIndex].part = partName;
                          newItems[editIndex].labour_cost = laborCost;
                          newItems[editIndex].part_cost = partCost;
                          setItemList(newItems);
                        }
                        handleClose();
                      }}
                      className="dark-purple-btn rounded-pill px-4 w-100"
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </Modal.Footer>
            </Modal>
          </div>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              fontSize: "12px",
              fontWeight: 400,
              color: "#FF4444",
              marginTop: "6px",
              marginLeft: "6px",
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                fontSize: "12px",
                fontWeight: 400,
                color: "#FF4444",
                marginTop: "6px",
                marginLeft: "6px",
              }}
            >
              {errorMsg.items && (typeof errorMsg.items === "string" ? errorMsg.items : Array.isArray(errorMsg.items) && typeof errorMsg.items[0] === "string" ? errorMsg.items[0] : Array.isArray(errorMsg.items) && errorMsg.items.length > 0 ? "Please complete all item fields" : "")}
            </span>
          </span>
          <div className="row gap-3 py-2 m-0">
            <div className="col-xl-2 d-flex py-3 rounded-4 gap-3" style={{ backgroundColor: "#F2E0FF" }}>
              <img src={labor} alt="labor" />
              <div className="d-flex flex-column">
                <p className="m-0 fs-13 fw-400" style={{ color: "#8790A1" }}>
                  Labor
                </p>
                <p className="m-0 fs-22 fw-600" style={{ color: "#172B4D" }}>
                  {itemList.reduce((sum, item) => sum + Number(item.labour_cost || 0), 0)}
                </p>
              </div>
            </div>
            <div className="col-xl-2 d-flex py-3 rounded-4 gap-3" style={{ backgroundColor: "#D5FFEE" }}>
              <img src={parts} alt="labor" />
              <div className="d-flex flex-column">
                <p className="m-0 fs-13 fw-400" style={{ color: "#8790A1" }}>
                  Parts
                </p>
                <p className="m-0 fs-22 fw-600" style={{ color: "#172B4D" }}>
                  {itemList.reduce((sum, item) => sum + Number(item.part_cost || 0), 0)}
                </p>
              </div>
            </div>
            <div className="col-xl-2 d-flex py-3 rounded-4 gap-3" style={{ backgroundColor: "#EFF0FF" }}>
              <img src={total} alt="labor" />
              <div className="d-flex flex-column">
                <p className="m-0 fs-13 fw-400" style={{ color: "#8790A1" }}>
                  Total
                </p>
                <p className="m-0 fs-22 fw-600" style={{ color: "#172B4D" }}>
                  {itemList.reduce((sum, item) => sum + Number(item.labour_cost || 0) + Number(item.part_cost || 0), 0)}
                </p>
              </div>
            </div>
          </div>
          {/* Table */}
          <div className="mt-3">
            <div className="table-wrapper overflow-x-auto">
              <table>
                <thead>
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                      {headerGroup.headers.map((header) => (
                        <th key={header.id} className="px-3 py-2" onClick={header.column.getToggleSortingHandler()}>
                          {flexRender(header.column.columnDef.header, header.getContext())}
                          {header.column.getIsSorted() === "asc" && " asc"}
                          {header.column.getIsSorted() === "desc" && " des"}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody>
                  {table.getRowModel().rows.map((row, index) => (
                    <tr key={"row" + index}>
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id} className="px-3 py-2">
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">Records per page: &nbsp;</span>
                <Dropdown.Toggle id="dropdown-basic" className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0">
                  <span className="bg-white no-of-rows rounded-3 px-2 py-2">
                    {pageSize} <img src={down} alt="" />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="my-2" style={{ minWidth: "unset", width: "30%" }}>
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item key={size} onClick={() => table.setPageSize(size)} active={pageSize === size} className="text-center">
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <button className="pagination-border bg-white rounded-circle p-2" onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>
                  <ChevronLeft className="pagination-color" />
                </button>

                {pageOptions.length > 0 &&
                  (() => {
                    const totalPages = pageOptions.length;
                    const maxVisible = 3;
                    let start = Math.max(0, pageIndex - Math.floor(maxVisible / 2));
                    let end = start + maxVisible;
                    if (end > totalPages) {
                      end = totalPages;
                      start = Math.max(0, totalPages - maxVisible);
                    }
                    const visiblePages = pageOptions.slice(start, end);
                    return (
                      <>
                        {visiblePages.map((pageNum) => (
                          <button key={pageNum} className={`pagination-border rounded-circle p-2 px-3 ${pageIndex === pageNum ? "dark-purple-btn" : "bg-white pagination-color"}`} onClick={() => table.setPageIndex(pageNum)}>
                            {pageNum + 1}
                          </button>
                        ))}
                        {visiblePages[visiblePages.length - 1] < totalPages - 1 && (
                          <>
                            <span className="mx-2 pagination-color">...</span>
                            <button className={`pagination-border rounded-circle p-2 px-3 ${pageIndex === totalPages - 1 ? "dark-purple-btn" : "bg-white pagination-color"}`} onClick={() => table.setPageIndex(totalPages - 1)}>
                              {totalPages}
                            </button>
                          </>
                        )}
                      </>
                    );
                  })()}

                <button className="pagination-border bg-white rounded-circle p-2" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
                  <ChevronRight className="pagination-color" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
